import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-dynamic-pagination',
  templateUrl: './dynamic-pagination.component.html',
  styleUrls: ['./dynamic-pagination.component.scss']
})
export class DynamicPaginationComponent implements OnInit {
  constructor(private router: Router, private route: ActivatedRoute) {}

  @Input() itemsPerPage: number = 0;
  @Input() data: any[] = [];
  @Output() pageChanged = new EventEmitter<any[]>();
  @Input() pageName: any;

  currentPage = 0;
  pageSize = 0;
  totalData = 0;


  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const page = parseInt(params['page'], 10);
  
      if (!isNaN(page) && page > 0) {
        this.currentPage = page - 1;
      } else {
        this.currentPage = 0;
      }
  
      setTimeout(() => {
        if (this.data.length > 0) {
          this.updateData();
        }
      });
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] || changes['itemsPerPage']) {
      this.pageSize = this.itemsPerPage;
      this.updateData();
    }
  }
  
  updateData(): void {
    this.totalData = this.data?.length;
    const start = this.currentPage * this.pageSize;
    const end = start + this.pageSize;
  
    if (start >= this.totalData) {
      this.currentPage = Math.max(0, Math.floor((this.totalData - 1) / this.pageSize));
    }
  
    const paginatedData = this.data.slice(start, end);
    this.pageChanged.emit([paginatedData, this.currentPage]);
  }
  

  changePage(pageIndex: number): void {
    if (pageIndex < 0 || pageIndex >= this.getTotalPages()) {
      return;
    }
  
    this.currentPage = pageIndex;
    this.router.navigate([], {
      queryParams: { page: this.currentPage + 1 },
      queryParamsHandling: 'merge',
      replaceUrl: false,
    });
  
    this.updateData();
  }
  
  getTotalPages(): number {
    return Math.ceil(this.totalData / this.pageSize);
  }

  getPageNumbers(): (number | string)[] {
    const totalPages = this.getTotalPages();
    const currentPage = this.currentPage;
    const pageNumbers: (number | string)[] = [];

    if (totalPages <= 1) return [0];

    pageNumbers.push(0);

    if (currentPage > 2) {
      pageNumbers.push('...');
    }

    for (let i = Math.max(1, currentPage - 1); i <= Math.min(totalPages - 2, currentPage + 1); i++) {
      pageNumbers.push(i);
    }

    if (currentPage < totalPages - 3) {
      pageNumbers.push('...');
    }

    if (totalPages > 1) {
      pageNumbers.push(totalPages - 1);
    }

    return pageNumbers;
  }
}
